<template>
  <div class="chart-wrapper">
    <div id="surveyStatisticsContainer">
    </div>
  </div>

</template>

<script>
import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/data';
import highchartTranslations from "@/config/highchart";
import dayjs from "dayjs";

export default {
  name: "SurveyStatisticsChart",
  props: {
    statistics: {
      type: Array,
      required: true
    },
    survey: {
      type: Object,
      required: true
    },
    language: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chart: null,
      ddd: null,
    }
  },
  methods: {
    createChart() {

      this.$nextTick(() => {
        let start = dayjs(this.survey.start).startOf('day');
        let end = dayjs(this.survey.end).startOf('day');
        let today = dayjs().endOf('day');

        const timeZoneOffset = today.utcOffset();

        if (start.isAfter(today)) return;
        if (end.isAfter(today)) end = today;

        const statistics = [];

        while (start.isBefore(end)) {
          const dayIndex = this.statistics.findIndex(s => dayjs(s.date).startOf('day').isSame(start));
          let answers = 0;
          if (dayIndex > -1) {
            answers = this.statistics[dayIndex].answers;
          }
          statistics.push([start.unix() * 1000, answers]);
          start = start.add(1, 'days').startOf('day');
        }

        Highcharts.setOptions({lang: highchartTranslations[this.language]});

        const chart = Highcharts.chart('surveyStatisticsContainer', {
          chart: {
            zoomType: 'x',
            backgroundColor: 'transparent',
            style: {
              fontFamily: 'Jost'
            },
            animation: false,
          },
          time: {
            timezoneOffset: -timeZoneOffset,
          },
          title: {
            text: null,
          },
          accessibility: {
            description: ''
          },
          xAxis: {
            type: 'datetime',
          },
          yAxis: {
            title: {
              text: this.$t('surveys.answers'),
            },
            tickInterval: 1,
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            area: {
              fillColor: {
                linearGradient: {
                  x1: 0,
                  y1: 0,
                  x2: 0,
                  y2: 1
                },
                stops: [
                  [0, Highcharts.color(this.$vuetify.theme.themes.light.info).setOpacity(0.1).get('rgba')],
                  [1, Highcharts.color(this.$vuetify.theme.themes.light.info).setOpacity(0).get('rgba')]
                ]
              },
              marker: {
                radius: 2
              },
              lineWidth: 1,
              states: {
                hover: {
                  lineWidth: 1
                }
              },
              threshold: null
            },
            series: {
              animation: false,
            }
          },
          series: [{
            type: 'area',
            name: this.$t('surveys.answers'),
            color: this.$vuetify.theme.themes.light.info,
            data: statistics,
          }],
          credits: false,
          /* responsive: {
            rules: [{
              condition: {
                maxWidth: 500
              },
              chartOptions: {
                pane: {
                  size: '72%'
                }
              }
            }]
          }
          */

        });
        this.chart = chart;
      })


    },
  },
  mounted() {
    this.createChart();
  },
  computed: {},
  watch: {
    statistics() {
      this.chart?.destroy?.();
      this.createChart();
    },
    language() {
      this.chart?.destroy?.();
      this.createChart();
    },
  }
}
</script>

<style scoped>

</style>
